<template>
    <div class="body">
        <h1>Forbidden!</h1>
        <h2>Code 403</h2>
    
        <button @click="goBackToDashboard">Go back {{ isBack ? '' : ' to dashboard'}} </button>
    </div>
</template>

<script>
export default {
    props:{
        eventId: String
    },
    computed:{
      isBack(){
        if(this.$route.query.back){
            return true
        }
        return null
      }  
    },
    methods:{
        goBackToDashboard(){
            if(this.isBack){
                this.$router.back()
                this.$router.back()
                return 
            }
            this.$router.push(`/dashboard/${this.eventId}`)
        }    
    }
}
</script>

<style scoped>
h1 {
    font-size: 4rem
}
h2{
    font-size: 1rem;
}

.body {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

button{
    padding: 10px;
    border: 1px solid black;
    background: white;
}

button:hover{
    background: rgb(245, 245, 245);
}
</style>